import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Gamepad2, Trophy, Radio, User } from "lucide-react";

const TABS = [
  { to: "/", label: "Home", icon: Gamepad2, testid: "bottomnav-home", exact: true },
  { to: "/sports", label: "Sports", icon: Trophy, testid: "bottomnav-sports" },
  { to: "/live-casino", label: "Live Casino", icon: Radio, testid: "bottomnav-livecasino" },
  { to: "/wallet", label: "Account", icon: User, testid: "bottomnav-account" },
];

const INACTIVE = "linear-gradient(-180deg, #32617f 20%, #1f4258 91%)";
const ACTIVE = "linear-gradient(-180deg, #ffc21a 10%, #e09a00 90%)";

export default function BottomNav() {
  const location = useLocation();
  const isActive = (t) =>
    t.exact ? location.pathname === "/" || location.pathname.startsWith("/games")
            : location.pathname.startsWith(t.to);

  return (
    <nav
      data-testid="bottom-nav"
      className="bbw-bottomnav lg:hidden fixed bottom-0 inset-x-0 z-50"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-4 gap-[3px] px-[3px] pt-[3px]">
        {TABS.map((t) => {
          const Icon = t.icon;
          const active = isActive(t);
          return (
            <Link
              key={t.to}
              to={t.to}
              data-testid={t.testid}
              className={`bbw-tab flex flex-col items-center justify-center gap-0.5 h-[54px] rounded-t-[27px] text-[11px] font-semibold text-white ${active ? "bbw-tab-active" : "bbw-tab-inactive"}`}
            >
              <Icon className="h-5 w-5" />
              {t.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
